import Linkify from "linkify-react";
import React, { ReactNode } from "react";
import { RiErrorWarningFill } from "react-icons/ri";

import { cn } from "~/utils/fontsConfig";

type Props = {
    title: string;
    message: string;
    linkText?: string;
    onLinkClick?: () => void;
    className?: string;
    footer?: ReactNode;
    showIcon?: boolean;
    status?: "warning" | "error" | "success" | "info";
};

export const SystemMessage = ({
    title,
    status,
    message,
    linkText,
    onLinkClick,
    className,
    footer,
    showIcon = true,
}: Props) => {
    const messageWithLineBreaks = message
        .split("\n")
        .map((line, index, array) => (
            <React.Fragment key={index}>
                {line}
                {index < array.length - 1 && index > 0 && <br />}{" "}
                {/* Add <br /> after every line except the last and the first*/}
            </React.Fragment>
        ));

    return (
        <div
            className={cn(
                "flex w-full gap-2 rounded-xl border border-none bg-v4-SUNSHINE p-2 md:gap-4 md:p-4",
                status === "warning" && "bg-v4-SUNSHINE",
                status === "error" && "bg-red-500",
                status === "success" && "bg-green-500", // add green options
                status === "info" && "bg-v4-PASTEL_BLUE", // add blue options
                className,
            )}
        >
            {showIcon && (
                <div>
                    <RiErrorWarningFill
                        className={cn(
                            "h-6 w-6 rounded-full text-black",
                            status === "error" && "text-white",
                        )}
                    />
                </div>
            )}

            <div className="flex w-full items-center justify-start gap-2 md:gap-4">
                <div className="flex w-full flex-col items-start justify-center gap-3">
                    <span
                        className={cn(
                            "text-sm font-medium leading-6 tracking-wider text-black",
                            status === "error" && "text-white",
                        )}
                    >
                        {title}
                    </span>

                    <div
                        className={cn(
                            "text-sm leading-6 tracking-wider text-black",
                            status === "error" && "text-white",
                        )}
                    >
                        <Linkify options={{ className: "break-all" }}>
                            {messageWithLineBreaks}
                        </Linkify>
                    </div>

                    {linkText && (
                        <div className="inline-flex items-center justify-start gap-2">
                            <button
                                onClick={onLinkClick}
                                className="text-xs font-medium leading-4 tracking-wider text-white underline"
                            >
                                {linkText}
                            </button>
                        </div>
                    )}
                    {footer}
                </div>
            </div>
        </div>
    );
};
